import { useSelector } from 'react-redux';

import { Nullable } from '../../../types/general';
import { RegistrationProjectsSource } from '../types';

import { getAuthFeatureFlags } from '../../../selectors/authFeatureFlags.selectors';

import { useUrlQueryParam } from '../../../hooks/useUrlQueryParam';
import { stringifyLocationQuery } from '../../../lib/url';

const UTM_PARAMS = '?utm_source=vchasno&utm_campaign=vchasno';

export const PROJECTS_REDIRECT_LINKS_MAP = {
    edi: `${config.EDI_HOST}${UTM_PARAMS}`,
    kasa: `${config.KASSA_HOST}${UTM_PARAMS}`,
    kep: `${config.KEP_HOST}${UTM_PARAMS}`,
    ttn: `${config.TTN_HOST}${UTM_PARAMS}`,
};

export const LANDINGS_REDIRECT_LINKS_MAP = {
    edo: 'https://vchasno.ua',
    edi: 'https://edi.vchasno.com.ua',
    kasa: 'https://kasa.vchasno.com.ua',
    kep: 'https://cap.vchasno.com.ua',
    ttn: 'https://vchasno.ua', // Because TTN landing doesn't exist yet
};

export const useRegistrationRedirectLink = () => {
    const source = useUrlQueryParam(
        'source',
    ) as Nullable<RegistrationProjectsSource>;

    const authFeatureFlags = useSelector(getAuthFeatureFlags);

    const redirectLink = authFeatureFlags.NEW_REGISTRATION_FLOW
        ? PROJECTS_REDIRECT_LINKS_MAP[source || ''] || '/app'
        : `/app/registration/choose-project${stringifyLocationQuery({
              source,
          })}`;

    return redirectLink;
};
